<template lang="pug">
v-dialog(v-model='dialog' dark max-width='800px' scrollable)
  //- template(#activator="{ on }")
  //-   slot(name="activator" v-bind="{ on }")
  v-card.pa-5(style="height:80vh")
    v-form(v-model="valid")
      p.text-h5 {{ title }}
      v-text-field(
        filled
        label="Название шаблона"
        v-model="form.name"
        :rules="[rules.required]"
      )
      select-project(
        v-model="form.project_id"
        label='Проект'
        filled
        :rules="[rules.required]"
      )
      select-project-role(
        v-model="form.project_role_id"
        filled
        :disabled="!form.project_id"
        :project-id="form.project_id"
      )
      select-template-category(
        :menu-props="{ auto: true }"
        v-model="form.question_category_id"
        :project-role-id="form.project_role_id"
        :project-id="form.project_id"
        :disabled="!form.project_id || !form.project_role_id"
        filled
        label='Категория'
      )
      app-editor(
        :rules="[rules.required]"
        v-model="form.text"
        filled
        placeholder="Текст шаблона"
        :key="key"
      )
      .my-4
      v-btn.mr-4(
        :disabled="!valid"
        color="success"
        @click="submitForm()"
      ) Сохранить
      v-btn.mr-4(text @click='dialog = false') Отменить
</template>

<script>
import rules from '@/lib/rules';
import AppEditor from '@/components/AppEditor.vue';
import SmartTable from '@/components/SmartTable/index.vue';
import { CRUDAnswerTemplates } from '@/services/API/_crud';
import SelectProject from '@/components/inputs/SelectProject.vue';
import SelectTemplateCategory from '@/components/inputs/SelectTemplateCategory.vue';
import SelectProjectRole from '@/components/inputs/SelectProjectRole.vue';

const DEFAULT_FORM = {
  project_id: null,
  project_role_id: null,
  question_category_id: null,
  text: '',
  name: '',
};

export default {
  components:{
    AppEditor,
    SmartTable,
    SelectProject,
    SelectTemplateCategory,
    SelectProjectRole,
  },
  props: {
    openOnButton: { type: Boolean, required: false, default: false },
    editData:{ type:Object, required: false, default:() => ({}) },
    value: { type: Boolean, required: true, default: false },
  },
  data() {
    return {
      valid: false,
      key: 1,
      dialog: false,
      form: { ...DEFAULT_FORM },
      rules,
    };
  },

  computed: {
    // isValidForm() {
    //   return Object.keys(this.form).every((v) => this.form[v]);
    // },
    title() {
      return this.editData.id ?  'Изменение шаблона' : 'Создание шаблона';
    },
  },

  watch:{
    dialog(v) {
      if (v) {
        Object.assign(this.form, this.editData);
        this.$nextTick(() => {
          this.key += 1;
        });
      }
      if (!v) this.$emit('close');
    },
    'value': {
      immediate: true,
      handler(v) {
        this.dialog = v;
      },
    },
  },

  methods: {
    async submitForm() {
      if (this.editData.id) await this.updateTemplate();
      else await this.createTemplate();
    },
    async updateTemplate() {
      try {
        const params = this.form;
        const { id } = this.editData;
        await CRUDAnswerTemplates.update(id, params);
        this.$toast.success('Шаблон обновлен');
        this.form = { ...DEFAULT_FORM };
        this.value = false;
        this.$emit('close');
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async createTemplate() {
      try {
        const params = this.form;
        params.question_category_id = 1;
        await CRUDAnswerTemplates.create(params);
        this.dialog = false;
        this.$toast.success('Шаблон успешно сохранен');
        this.form = {};
        this.$emit('close');
      } catch (err) {
        this.$toast.error(err.response.data.result_message);
      }
    },
  },
};
</script>

<style>

</style>
